import { useCallback } from 'react';
import { sortBy } from 'lodash-es';
import { SimpleTable } from '../../../components/table/SimpleTable';
import { DownloadLink } from './DownloadLink.jsx';
import { Converter } from './Converter.jsx';

export function RawFiles({ rawFiles, scrollTop, handleScroll }) {
  const containerRef = useCallback(
    (node) => {
      if (node) {
        node.scrollTop = scrollTop;
      }
    },
    [scrollTop],
  );

  return rawFiles?.length ? (
    <>
      <SimpleTable
        rows={sortBy(rawFiles, 'file').map((file) => ({
          'Raw File': <DownloadLink url={file.file} />,
          Format: file?.format,
          Converter: <Converter file={file} />,
          Crop: file.crop,
          Year: file.year,
          Area: Number(file.area).toFixed(2),
          ...getStats(file.stats),
        }))}
        ref={containerRef}
        onScroll={handleScroll}
        sx={{
          maxHeight: 300,
          overflow: 'auto',
          '& .MuiTableCell-root': {
            py: 0.5,
            px: 1,
            fontSize: '0.875rem',
          },
          '& .MuiTableHead-root': {
            position: 'sticky',
            top: 0,
            backgroundColor: 'background.paper',
            zIndex: 1,
          },
        }}
      />
    </>
  ) : null;
}

function getStats(stats) {
  const [first] = Object.values(stats || {});

  return {
    Count: first?.count?.toLocaleString(),
    Avg: first?.avg?.toLocaleString(),
    Min: first?.min?.toLocaleString(),
    Max: first?.max?.toLocaleString(),
  };
}
